import { combineReducers } from 'redux'
import { fetchData } from '../../api'

const FETCH_PLEDGESPAGE_REQUEST = 'pledges/FETCH_PLEDGESPAGE_REQUEST'
const FETCH_PLEDGESPAGE_SUCCESS = 'pledges/FETCH_PLEDGESPAGE_SUCCESS'
const FETCH_PLEDGESPAGE_FAILURE = 'pledges/FETCH_PLEDGESPAGE_FAILURE'

const pledgespage = (state = {}, action) => {

    switch (action.type) {

        case FETCH_PLEDGESPAGE_SUCCESS:
            return action.response;

        default: 
            return state
    }  
}

const reducer = combineReducers({
    pledgespage
})

export const fetchPledgesPage = () => (dispatch) => {
    
    dispatch({type: FETCH_PLEDGESPAGE_REQUEST})

    return fetchData('wpapi/pledgespage')
        .then(response => {
            dispatch({
                type: FETCH_PLEDGESPAGE_SUCCESS,
                response
            })
        })
        .catch(error => {
            dispatch({
                type: FETCH_PLEDGESPAGE_FAILURE,
                error
            })
        }); 
}

export const getPledgesPage = state => state.pledgespage.pledgespage

export default reducer



// WEBPACK FOOTER //
// ./client/modules/Pledges/redux.js